import React from "react";
import './common_css.css'

const StackedBar = ({ segments, height = 112, width = 34 }) => {
    return (
        <div
            className="stacked-bar"
            style={{ height: `${height}px`, width: `${width}px` }}
        >
            {segments.map((seg, index) => (
                <div
                    key={index}
                    className="segment-stacked"
                    style={{
                        height: `${seg.value}%`, // proportion of bar
                        backgroundColor: seg.color,
                    }}
                />
            ))}
        </div>
    );
};

export default StackedBar;
